import app from "../_app";
import axios from "axios";

const filters = document.querySelector('.js-filters');

if (filters) {
    let triggers;
    let filtersContent;
    let filtersReset;
    let priceFilter;
    let filterHeadings;

    const toggleFilters = () => {
        if (filters.hasAttribute('data-open')) {
            filters.removeAttribute('data-open');
            app.unlockBody();
        } else {
            app.lockBody();
            filters.setAttribute('data-open', '');
        }
    }

    const priceFilterInit = () => {
        if (priceFilter) {
            const minInput = priceFilter.querySelector('.js-filters-price-min-input');
            const maxInput = priceFilter.querySelector('.js-filters-price-max-input');

            const range = priceFilter.querySelector('.js-filters-price-range');
            const minRange = priceFilter.querySelector('.js-filters-price-min-range');
            const maxRange = priceFilter.querySelector('.js-filters-price-max-range');

            let min = +minInput.value;
            let max = +maxInput.value;

            const calculatePriceRange = () => {
                const left = 100 / (+maxRange.max - +minRange.min) * (min - +minRange.min);
                const right = Math.abs(100 / (+maxRange.max - +minRange.min) * (max - +maxRange.max));

                range.style.setProperty('left', `${left}%`);
                range.style.setProperty('right', `${right}%`);
            }

            const priceChangeHandler = e => {
                const currentInput = e.currentTarget;
                const { type } = currentInput.dataset;

                let newMin = +(type === 'min' ? currentInput.value || min : min);
                let newMax = +(type === 'max' ? currentInput.value || max : max);

                if (type === 'min' && newMin >= newMax) {
                    newMin = newMax - 1;
                } else if (type === 'max' && newMax <= newMin) {
                    newMax = newMin + 1;
                }

                if (newMin < minRange.min) {
                    newMin = minRange.min;
                }

                if (newMax > maxRange.max) {
                    newMax = maxRange.max;
                }

                min = newMin;
                max = newMax;

                minRange.value = min;
                minInput.value = min;
                minInput.parentElement.lastElementChild.innerText = min;
                minInput.setAttribute('max', max);

                maxRange.value = max;
                maxInput.value = max;
                maxInput.parentElement.lastElementChild.innerText = max;
                maxInput.setAttribute('min', min);

                calculatePriceRange();
            }

            calculatePriceRange();

            [minInput, maxInput].map(input => input.addEventListener('change', priceChangeHandler));
            [minRange, maxRange].map(input => input.addEventListener('input', priceChangeHandler));
        }
    }

    const filtersChangeHandler = async e => {
        e.preventDefault();

        const formData = new FormData(filters);
        const params = new URLSearchParams(formData);
        const getUrl = `${filters.getAttribute('action')}?${params.toString()}`;

        let response = await axios.get(getUrl);

        if (response.status === 200) {
            updateFilters(response.data);
        }
    };

    const filtersResetHandler = async () => {
        const searchQuery = filters.querySelector('input[name="q"]') ? filters.querySelector('input[name="q"]').value : false;
        let url = filters.getAttribute('action');

        if(searchQuery) {
            url = filters.getAttribute('action') + searchQuery !== null ? 'search?q=' + searchQuery : '';
        }

        let response = await axios.get(url);

        if (response.status === 200) {
            updateFilters(response.data);
        }
    }

    const updateFilters = data => {
        const parser = new DOMParser();
        const htmlResponse = parser.parseFromString(data, "text/html");
        const filtersScrollPosition = filtersContent.scrollTop;
        const currentFilterHeadingIndex = filterHeadings.findIndex(filterHeading => filterHeading.hasAttribute('data-open')) || 0;

        filters.innerHTML = htmlResponse.querySelector('.js-filters').innerHTML;

        initFilters();
        filterHeadingClickHandler({ currentTarget: filterHeadings[currentFilterHeadingIndex] }, true);
        filtersContent.scrollTo({ top: filtersScrollPosition })
    }

    const filterHeadingClickHandler = ({ currentTarget }, noTransition = false) => {
        filterHeadings.map(filterHeading => {
            const filterContent = filterHeading.nextElementSibling;
            let doClose = true;

            if (currentTarget === filterHeading && !filterHeading.hasAttribute('data-open')) {
                doClose = false;
            }

            if (noTransition) {
                [...filterHeading.querySelectorAll('svg path')].map(path => path.style.setProperty('transition', 'initial'));
                filterContent.style.setProperty('transition', 'initial');
            }

            if (doClose) {
                filterHeading.removeAttribute('data-open');
                filterContent.style.height = 0;
            } else {
                filterContent.style.height = `${filterContent.scrollHeight}px`;
                filterHeading.setAttribute('data-open', '');
            }

            setTimeout(() => {
                [...filterHeading.querySelectorAll('svg path')].map(path => path.style.removeProperty('transition'));
                filterContent.style.removeProperty('transition');
            }, 200);
        });
    }

    const initFilters = () => {
        if (triggers) {
            triggers.map(trigger => trigger.removeEventListener('click', toggleFilters));
        }

        triggers = [...document.querySelectorAll('.js-filters-trigger')];
        filtersContent = filters.querySelector('.js-filters-content');
        filtersReset = [...filters.querySelectorAll('.js-filters-reset')];
        priceFilter = filtersContent.querySelector('.js-filters-price');
        filterHeadings = [...filtersContent.querySelectorAll('.js-filters-heading')];

        filterHeadings.map(filterHeading => filterHeading.addEventListener('click', filterHeadingClickHandler));

        priceFilterInit();
        triggers.map(trigger => trigger.addEventListener('click', toggleFilters));
        filtersReset.map(reset => reset.addEventListener('click', filtersResetHandler));
    }

    initFilters();
    filters.addEventListener('change', filtersChangeHandler);
    filterHeadingClickHandler({ currentTarget: filterHeadings[0] }, true);
}
